/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */


import { createPrivateAccountHook } from '../../core/factories/createPrivateAccountHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetSessionsRow } from '../openapi-types.gen.js';
import { type useGetSessionsArgs, useGetSessionsSpec } from '../specs/me.spec.gen.js';

export type { GetSessionsRow } from '../openapi-types.gen.js';
export type { useGetSessionsArgs } from '../specs/me.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): kind.
 */
export const useGetSessions = createPrivateAccountHook(useGetSessionsSpec);


/**
 * Hover/intent prefetch companion for `useGetSessions`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetSessions();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetSessions = createPrefetchHook(useGetSessionsSpec);
